import AppCardsCarousel from '@js/components/pageBuilder/AppCardsCarousel.vue'
import AppCardsCarouselSlide from '@js/components/pageBuilder/AppCardsCarouselSlide.vue'
import AppCourseFormat from '@js/components/pageBuilder/AppCourseFormat.vue'
import AppTabs from '@js/components/pageBuilder/AppTabs.vue'
import AppTabPanel from '@js/components/pageBuilder/AppTabPanel.vue'
import AppPromotion from '@js/components/pageBuilder/AppPromotion.vue'
import AppIframeBlock from '@js/components/pageBuilder/AppIframeBlock.vue'
import AppEmbedCode from '@js/components/pageBuilder/AppEmbedCode.vue'

const pageBuilderComponents = [
  AppCardsCarousel,
  AppCardsCarouselSlide,
  AppCourseFormat,
  AppTabs,
  AppTabPanel,
  AppPromotion,
  AppIframeBlock,
  AppEmbedCode,
]
export default pageBuilderComponents
